import Image from 'next/image';
import React from 'react';

import type { ISchoolFeature } from '../home.interface';

interface IProps {
  schdistfeature: ISchoolFeature;
  index: number;
}

export const Schooldistrictfeature = ({ schdistfeature, index }: IProps) => {
  const { imageUrl, title, description, alt } = schdistfeature;

  // const serviceImage = [
  //   {
  //     imagePath: `${imageUrl}/feature_${index}-2x.png`,
  //     imageWidth: 1024,
  //     alt,
  //   },
  // ];

  const defaultImage: string = `${imageUrl}/feature_${index}-1x.png`;
  return (
    <div
      className={`mx-2 mt-12 flex flex-col items-center justify-center gap-y-2 px-4 md:mx-0 md:flex-row md:gap-x-[5%] md:gap-y-0 md:px-[5%] lg:gap-x-[10%] lg:px-[2%] ${
        index % 2 === 0 ? 'mt-12 md:flex-row-reverse xl:mt-4' : ''
      }`}
    >
      <div className="w-[80%] md:w-[60%] lg:w-[50%] ">
        {/* <OptimisedImage data={serviceImage} defaultImagePath={defaultImage} /> */}
        <Image
          src={`${imageUrl}/feature_${index}-2x.png` || defaultImage}
          width={1024}
          height={1024}
          alt={alt}
        />
      </div>
      <div className="mt-1 flex flex-col text-center md:-mt-4 md:w-[60%] md:text-start lg:max-w-[40%]">
        <div className="mt-4 text-[22px] font-medium text-[#3D3E40] md:text-[26px] lg:text-4xl">
          {title}
        </div>
        <div className="ml-4 w-[90%] py-4 text-[15px] font-normal text-[#616366] md:ml-0 md:text-[18px]">
          {description}
        </div>
      </div>
    </div>
  );
};
